import { Box, Typography } from "@mui/material";
import React from "react";
import CommonHeroSection from "./CommonHerosection"

function TermsConditions() {
  return (
    <>
      <CommonHeroSection
        title="Terms & Conditions"
        height="50vh"
        align="center"
        breadcrumbs={[{ label: "Home", href: "/" }, { label: "Terms & Conditions" }]}
      />

      <Box component="section" sx={{ padding: "40px 0 80px 0" }}>
        <Box className="scrn-container">
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, color: "#000", mb: 3 }}
          >
            Terms & Conditions - Premshop
          </Typography>

          <Typography sx={{ mb: 2 }}>
            By accessing or using this website, you agree to the following Terms
            & Conditions. Please review them carefully before participating in
            any promotional activity, contest, or using our services.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            1. Use of Website
          </Typography>
          <Typography sx={{ mb: 2 }}>
            You agree to use our website responsibly and comply with all
            applicable laws. Premshop may restrict or block access if misuse or
            suspicious activity is detected.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            2. Product Information
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Product details, images, and pricing may vary due to display
            differences or supplier updates. We strive for accuracy but errors
            may occur.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            3. Pricing & Payments
          </Typography>
          <Typography sx={{ mb: 2 }}>
            All prices are inclusive of applicable taxes unless stated
            otherwise. Payments must be successfully completed for an order to
            be confirmed.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            4. Order Confirmation
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Order confirmation will be sent via email/SMS. Orders may be
            cancelled due to invalid details, stock unavailability, or system
            errors.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            5. Shipping & Delivery
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Delivery timelines may vary based on location and courier
            conditions. Risk transfers to the customer upon delivery.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            6. Returns & Refunds
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Returns are accepted as per our Return Policy. Refunds are issued
            after product inspection and approval.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            7. Intellectual Property
          </Typography>
          <Typography sx={{ mb: 2 }}>
            All logos, designs, images, and content on this website belong to
            Premshop or respective owners. Unauthorized use is strictly
            prohibited.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            8. Limitations of Liability
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Premshop is not liable for indirect or consequential losses arising
            from website usage, delays, or product issues beyond our control.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            9. Prize Conditions
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Prizes are non-transferable, non-exchangeable, and not redeemable
            for cash. Premshop reserves the right to substitute prizes with
            items of equal or greater value.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            10. Winner Announcement
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Winners will be announced on Premshop’s official Instagram handle
            (@premshop) and website. They will also be contacted via DM/email
            for verification and prize fulfilment.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            11. Evaluation & Disqualification Rights
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Premshop reserves the right to evaluate all entries based on
            internal criteria. Participants engaging in fraudulent or
            manipulated activity (including bots, scripts, or automated tools)
            will be disqualified immediately.
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Entries without valid proof of purchase or found fraudulent will be
            rejected without notice.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            12. Usage Rights for Submitted Content
          </Typography>
          <Typography sx={{ mb: 2 }}>
            By participating, consumers grant Premshop the unrestricted right to
            use their submitted video content for promotional purposes across
            digital and print platforms. Participants confirm that the content
            is original and does not violate third-party rights.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            13. Participant Responsibility
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Participants agree to take full responsibility for any legal claims
            or damages arising from their submitted content or violations of
            these terms, including attorney fees.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            14. Personal Data Usage
          </Typography>
          <Typography sx={{ mb: 2 }}>
            By entering any contest, participants consent to the collection and
            use of their personal data (name, email, Instagram handle, etc.) for
            winner selection, verification, and prize delivery. Data is
            processed per Premshop’s Privacy Policy.
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Personal data will not be shared with third parties for marketing
            purposes without explicit consent.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 4 }}>
            15. Terms and Conditions
          </Typography>

          <Typography sx={{ mb: 2 }}>
            You should assume that all materials, designs, text, and images
            (collectively, the <strong>"Materials"</strong>) displayed on the
            site are the copyrighted property of Premshop or its Associates
            unless otherwise stated.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            You shall not claim any rights over the Intellectual Property in the
            Materials by purchasing, subscribing, or accessing the site. You
            cannot modify, copy, distribute, transmit, reproduce, publish,
            license, or create derivative works from the Materials.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            In case of a breach or threatened breach, Premshop is entitled to
            seek injunctive relief along with other legal remedies.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            Unauthorized use of the Materials is strictly prohibited and
            violates copyright, trademark, and other applicable laws.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            Premshop does not guarantee or assure any specific results from its
            products or services.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            While Premshop makes efforts to include accurate and updated
            information, it makes no warranties regarding accuracy, product
            specifications, prices, or availability. Premshop assumes no
            responsibility for typographical or technical errors.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            Information on this site may change without notice.
            Products/services apply only within India unless stated otherwise.
            Users outside India must comply with local laws.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            Use of the site is at your own risk. Premshop is not responsible for
            any damages, viruses, or losses caused by accessing or downloading
            materials from the site.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            All content is provided <strong>"AS IS"</strong> without warranties,
            expressed or implied, including merchantability or fitness for a
            particular purpose.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3 }}>
            Contact Us
          </Typography>
          <Typography sx={{ color: "#444", lineHeight: 1.7 }}>
            For any questions about these Terms & Conditions, contact us at:
            <br />
            Email: support@premshop.in <br />
            Phone: +91 8115494617
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default TermsConditions;
